import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const AnualOcurrencesEvolution = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Ocorrências por ano'}
            horizontal={false}
            subtitles={chartData?.annualOcurrencesEvolution?.map((item) => item.description)}
            values={chartData?.annualOcurrencesEvolution?.map((item) => item.total || 0)}
        />
    );
};